export default __webpack_public_path__ + "static/media/ic_bill.e501c401.svg";